import axios from 'axios';
import { setGlobal, getGlobal } from 'reactn';
import defaultGlobalState from '../defaultGlobalState';

const API_URL = process.env.REACT_APP_API_URL;

export const signup = async (first_name, last_name, email, password) => {
  try {
    const res = await axios.post(`${API_URL}/signup`, {
      first_name,
      last_name,
      email,
      password,
    });
    if (!res.error) {
      setGlobal({ SignupResponseData: res.data });
      return true;
    }
  } catch (error) {
    return error?.response.data;
  }
};

export const signin = async (email, password) => {
  try {
    const res = await axios.post(`${API_URL}/signin`, { email, password });
    const { data: jwt } = res;
    const { id: userId } = jwt;
    if (!jwt.error) {
      setGlobal({ jwt, userId });
      localStorage.setItem('jwt', JSON.stringify(jwt));
    }
  } catch (error) {
    if (error.response.status === 400) await resendSignupVerification(email);
    return error?.response.data;
  }
};

export const signout = () => {
  // log user out by restoreing global state to default values
  setGlobal(defaultGlobalState);
  // remove jwt from local storage as well
  localStorage.removeItem('jwt');
};

export const changeUserPassword = async (password) => {
  try {
    const res = await axios.post(`${API_URL}/customer-edit-credentials`, {
      password,
    });
    return res;
  } catch (error) {
    return error?.response.data;
  }
};

export const changeUserPassword2 = async (password, token) => {
  axios.defaults.headers.common['x-auth-token'] = token;

  try {
    const res = await axios.post(`${API_URL}/edit-credentials/${token.token}`, {
      password,
    });

    const jwt = localStorage.setItem('jwt', JSON.stringify(res.data));
    setGlobal({ jwt });
  } catch (error) {
    return error?.response.data;
  }
};

export const emailVerification = async (token) => {
  try {
    const verification = await axios.post(`${API_URL}/validate-email/${token}`);
    setGlobal({ EmailVerification: verification.data });
  } catch (error) {
    console.error(error.response.status);
    if (error.response.status === 500) localStorage.removeItem('jwt');
    return error?.response;
  }
};

export const resendSignupVerification = async (email) => {
  try {
    const res = await axios.post(`${API_URL}/resend-signup-verification`, {
      email,
    });
    return res.data;
  } catch (error) {
    return error?.response.data;
  }
};

export const forgotCredentials = async (email) => {
  try {
    const forgotCreds = await axios.post(`${API_URL}/forgot-credentials`, {
      email,
    });
    setGlobal({ ForgotCreds_Response: forgotCreds.data });
    return forgotCreds.data;
  } catch (error) {
    return error?.response.data;
  }
};

// add methods to object to handle warning no-anonymous-default-export
const authObject = {
  signup,
  signin,
  signout,
  changeUserPassword,
  changeUserPassword2,
  emailVerification,
  resendSignupVerification,
  forgotCredentials,
};

export default authObject
